<form [formGroup]="frmProfile" (submit)="OnFinishStep()">
  <div class="step-section" [ngClass]="{'fly-out': registerService._isFlyout}">
    <h3>Tell us about your profession, specialty and (optionally) your sub-specialty</h3>
    <div class="field">
      <select class="inputvalid" (change)="onIndustryChange($event)" formControlName="IndustryId">
        <option selected="null" value="0" disabled>
          Choose industry *
        </option>
        <option *ngFor="let mItem of dbIndustries" value="{{mItem.id}}" [disabled]="mItem.status == 1"> {{mItem.name}} <span *ngIf="mItem.status == 1" class="small"> (coming soon)</span></option>
      </select>
      <label>Profession</label>
    </div>
    <div class="field">
      <select class="inputvalid disabled" (change)="onSpecialtiesChange($event)" formControlName="SpecialtyId">
        <option selected="null" value="null" disabled>
          Choose specialty *
        </option>
        <option *ngFor="let mItem of dbSpecialties" value="{{mItem.id}}" [disabled]="mItem.status == 1"> {{mItem.name}} <span *ngIf="mItem.status == 1" class="small"> (coming soon)</span> </option>
      </select>
      <label>Specialty</label>
    </div>
    <div class="field">
      <select class="inputvalid disabled" formControlName="SubSpecialtyId">
        <option selected="null" value="null" disabled>
          Choose sub-specialty
        </option>
        <option *ngFor="let mItem of dbSubSpecialties" value="{{mItem.id}}" [disabled]="mItem.status == 1"> {{mItem.name}} <span *ngIf="mItem.status == 1" class="small"> (coming soon)</span> </option>
      </select>
      <label>Sub-Specialty</label>
    </div>
  </div>
  <div class="step-section">
    <h3>When did you start this profession?</h3>
    <div class="row">
      <div class="field half">
        <select class="inputvalid" formControlName="MonthStarted">
          <option selected="null" value="null" disabled>
            Choose month *
          </option>
          <option *ngFor="let mItem of months" value="{{mItem.id}}"> {{mItem.name}} </option>
        </select>
        <label>Month</label>
      </div>
      <div class="field half">
        <select class="inputvalid" formControlName="YearStarted">
          <option selected="null" value="null" disabled>
            Choose year *
          </option>
          <option *ngFor="let yItem of years" value="{{yItem}}"> {{yItem}} </option>
        </select>
        <label>Year</label>
      </div>
    </div>
  </div>
  <div class="step-complete-skip" >
    <a (click)="OnSkipStep()" *ngIf="profileService.submitedStep[0]">Skip this step</a>
    <button class="btn primary" type="submit" [disabled]=frmProfile.invalid>Go To Profile</button>
  </div>
</form>

